/*
  src/redux/passwordReset/constants.js

  Created by erikchristensen on 11/22/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

function createConstant(action){
  return ['portal', 'passwordReset', action].join('/');
}

export const RESET_LINK_REQUESTED = createConstant('RESET_LINK_REQUESTED');
export const RESET_LINK_SENT = createConstant('RESET_LINK_SENT');
export const RESET_LINK_FAILED_TO_SEND = createConstant('RESET_LINK_FAILED_TO_SEND');
export const PASSWORD_RESET_REQUESTED = createConstant('PASSWORD_RESET_REQUESTED');
export const PASSWORD_RESET = createConstant('PASSWORD_RESET');
export const PASSWORD_FAILED_TO_RESET = createConstant('PASSWORD_FAILED_TO_RESET');



// WEBPACK FOOTER //
// ./src/shared/redux/passwordReset/constants.js